import React from 'react'
import styled from 'styled-components'
import { AutoRow, RowBetween, RowFixed } from 'components/Row'
import { ExternalLink, TYPE } from 'theme'
import { useEthPrices } from 'hooks/useEthPrices'
import { formatDollarAmount } from 'utils/numbers'
import Polling from './Polling'
import { DEX_URL } from '../../constants'
import { HYDRA_DOCS_URL } from '../../constants'

const Wrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.black};
  padding: 10px 20px;
`

const Item = styled(TYPE.main)`
  font-size: 12px;
`

const StyledLink = styled(ExternalLink)`
  font-size: 12px;
  color: ${({ theme }) => theme.text1};
`

const TopBar = () => {
  const ethPrices = useEthPrices()
  return (
    <Wrapper>
      <RowBetween>
        <Polling />
        <AutoRow gap="6px">
          <RowFixed>
            Hydra Price:
            <Item fontWeight="700" ml="4px">
              {formatDollarAmount(ethPrices?.current, 4)}
            </Item>
          </RowFixed>
        </AutoRow>
        <AutoRow gap="6px" style={{ justifyContent: 'flex-end' }}>
          {/* <StyledLink href="https://v2info.hydradex.org/">V2 Analytics</StyledLink> We do not use V2.info in HydraGon for now */}
          <StyledLink href={`${HYDRA_DOCS_URL}`}>Docs</StyledLink>
          <StyledLink href={`${DEX_URL}/#/swap`}>App</StyledLink>
        </AutoRow>
      </RowBetween>
    </Wrapper>
  )
}

export default TopBar
